<div *ngIf="booking">
    <div class="header">
        <ng-container *ngIf="!isEditing; else form">
            <h1>{{title}} :
                <strong [innerHTML]="booking?.agencyTitle || booking?.introduction?.title"></strong> -
                <span>{{booking.idItem}}/{{booking.idVersion}}</span>
            </h1>
            <div class="spacer"></div>
            <btn type="actionMore"
                 icon="fa-pen"
                 (onClick)="edit()"></btn>
        </ng-container>
        <ng-template #form>
            <text *ngIf="isEditing" class="titleInput"
                  [fieldConfig]="titleFormConfig">
            </text>
            <div class="spacer"></div>
            <btn type="action"
                 icon="fa-times"
                 class="icon"
                 (onClick)="isEditing = false;"></btn>
            <btn type="actionPrincipal"
                 icon="fa-check"
                 (onClick)="updateAgencyTitle()"></btn>
        </ng-template>
    </div>
    <div class="description" *ngIf="description">
        <label [innerHTML]="description"></label>
    </div>
    <div class="content">
        <div class="text" *ngIf="booking?.introduction?.text">
            <label [innerHTML]="booking?.introduction?.text"></label>
        </div>
        <div class="data">
            <div class="date box">
                {{wording.travelFrom}}
                    <span> {{booking.begin | dateMoment:"ddd DD/MM/YY" }} </span>
                {{wording.travelTo}}
                    <span> {{booking.end | dateMoment: "ddd DD/MM/YY"}} </span>
            </div>
            <div class="resumeCustomer box">
                <span> {{wording.customer}} : </span>
                <span>{{customer?.value | travellerIdentity}}</span>
            </div>
            <div class="resumeTraveller box">
                <span> {{wording.traveller}} : </span>
                <span>{{resumeTraveller}}</span>
            </div>

        </div>

    </div>
</div>
